import React from 'react';
import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';

import ButtonComponent from '@prisjakt/ui-button';
import GiftIcon from 'mdi-react/GiftIcon';
import Badge from '../badge';

type Props = {
  onClick: () => void;
  hasUnread: boolean;
  alternatePosition?: boolean;
};

export default function ChangelogToggle({
  onClick,
  hasUnread,
  alternatePosition,
}: Props) {
  return (
    <Button
      onClick={onClick}
      variant={alternatePosition ? 'text' : 'default'}
      color={alternatePosition ? 'quarternary' : 'primary'}
      size="small"
      $alternateStyling={alternatePosition}
    >
      <Inner $alternateStyling={alternatePosition}>
        <Badge noOutline={alternatePosition} />
        <GiftIcon />
      </Inner>
    </Button>
  );
}

type StyleProps = {
  $alternateStyling?: boolean;
};

const Button = styled(ButtonComponent)<StyleProps>`
  position: relative;
  padding: ${p => (p.$alternateStyling ? 0 : layout.measurements.spacingSmall)};
  width: ${p =>
    p.$alternateStyling ? layout.sidebarMenuWidth.desktop.rem : 'auto'};
  border-radius: 50%;
  color: ${p =>
    p.$alternateStyling ? p.theme.icons.secondary : p.theme.header.fg};
`;

const Inner = styled.div<StyleProps>`
  position: ${p => (p.$alternateStyling ? 'relative' : 'unset')};
  display: flex;
`;
